import { render } from "./EditServiceBox.vue?vue&type=template&id=1d2a7a17&scoped=true&ts=true"
import script from "./EditServiceBox.vue?vue&type=script&lang=ts"
export * from "./EditServiceBox.vue?vue&type=script&lang=ts"

import "./EditServiceBox.vue?vue&type=style&index=0&id=1d2a7a17&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2a7a17"]])

export default __exports__